/**
 * §7.13 Final CTA — closer.  Dual CTAs: Purchase License + Schedule
 * Enterprise Demo.  Trust chips underneath.
 */

import React from 'react'
import { CreditCard, Calendar, ShieldCheck } from 'lucide-react'
import {
  Container, Eyebrow, GradientButton, GhostButton,
} from '@/components/landing/design-system'

export default function FinalCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-[0.6]"
        style={{ background: 'radial-gradient(60% 45% at 50% 20%, rgba(255,193,7,0.16), transparent 70%)' }} />
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide">
        <div className="relative rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8 md:p-12 lg:p-14 backdrop-blur-xl overflow-hidden">
          <div className="pointer-events-none absolute -top-20 -left-20 h-64 w-64 rounded-full bg-brand-gold/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="relative flex flex-col items-center text-center gap-6 max-w-3xl mx-auto">
            <Eyebrow>Start Today</Eyebrow>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.05]">
              Start building your{' '}
              <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">AI trading business today.</span>
            </h2>
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">
              Choose the licence that matches your business goals and launch your own
              enterprise AI trading SaaS platform powered by Kalki Ai Cloud.
            </p>
            <div className="flex flex-col sm:flex-row items-stretch gap-3 pt-2">
              <GradientButton href="#pricing-plans" size="lg">
                <CreditCard className="h-4 w-4" /> Purchase license
              </GradientButton>
              <GhostButton href="/contact" size="lg" trailingIcon>
                <Calendar className="h-4 w-4" /> Schedule enterprise demo
              </GhostButton>
            </div>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-[11px] text-zinc-500">
              <span className="inline-flex items-center gap-1.5"><ShieldCheck className="h-3 w-3 text-emerald-400" /> PCI-DSS-compliant checkout</span>
              <span>·</span><span>Instant provisioning</span>
              <span>·</span><span>Cancel or upgrade any time</span>
              <span>·</span><span>Enterprise support included</span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
